import React, { useState, useRef } from "react";
import {
  Typography,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Box,
  Chip,
  Autocomplete,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Delete } from "@mui/icons-material";
import { Formik, Form, FieldArray } from "formik";
import ReusableDialog from "../../../../common/dialog/dialog";
import Signature from "../../../../common/signature/signature";

const staffs = ["staff1", "staff2", "staff3"];

const PropertyInventoryAdmission = () => {
  const signatureRef = useRef(null);
  const signatureRefChild = useRef(null);
  const [openAddItemDialog, setOpenAddItemDialog] = useState(false);
  const [newItem, setNewItem] = useState({
    date: "",
    size: 0,
    quantity: 0,
    teamDescription: "",
    description: "",
    staffName: "",
    childSignature: "",
    methodOfDisposal: "",
    dateOfDisposal: "",
    staffSignature: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleAddItem = (setFieldValue, items) => {
    const signatureData = signatureRef.current?.getSignatureData();
    const signatureDataChild = signatureRefChild.current?.getSignatureData();

    if (!signatureData || !signatureDataChild) {
      alert("Please provide both signatures");
      return;
    }

    setFieldValue("items", [
      ...items,
      {
        ...newItem,
        staffSignature: signatureData,
        childSignature: signatureDataChild,
      },
    ]);

    setNewItem({
      date: "",
      size: "",
      quantity: "",
      teamDescription: "",
      description: "",
      staffName: "",
      childSignature: "",
      methodOfDisposal: "",
      dateOfDisposal: "",
      staffSignature: "",
    });
    setOpenAddItemDialog(false);
  };

  // Check if all fields are filled
  const isAddButtonDisabled = !(
    newItem.date &&
    newItem.size &&
    newItem.quantity &&
    newItem.teamDescription &&
    newItem.description &&
    newItem.staffName &&
    newItem.methodOfDisposal &&
    newItem.dateOfDisposal
  );

  return (
    <Formik
      initialValues={{ items: [] }}
      onSubmit={(values) => {
        console.log(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className='admission-form'>
          <Grid item>
            <Chip label={"Admission"} />
          </Grid>
          <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
            Property Inventory
          </Typography>
          <Divider />
          <Typography sx={{ fontSize: "14px" }} mt={3} mb={4}>
            All property of the child is to be placed onto this document, this includes clothing, footwear, jewellery,
            electronics and any item of value. Upon the child receiving items into the home section 1-6 is to be
            completed, upon any form of disposal i.e. thrown in bin, given to charity or passed to parents etc is to be
            completed on section 7-10. Completing sections 1-6 indicate the items are still located within the home. On
            completion of sections 7-10 detail the items are not in possession of the child/home.
          </Typography>

          <FieldArray name='items'>
            {({ remove }) => (
              <TableContainer component={Paper}>
                <Table aria-label='property inventory table'>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Date
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Size
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Quantity
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Team Description
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Staff Name & Description
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Child Signature
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Method of Disposal
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Date of Disposal
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Staff Name & Signature
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", backgroundColor: "#E3F2FD", fontSize: "12px", color: "#1751D0" }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {values.items.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.date}</TableCell>
                        <TableCell>{item.size}</TableCell>
                        <TableCell>{item.quantity}</TableCell>
                        <TableCell>{item.teamDescription}</TableCell>
                        <TableCell>
                          {item.staffName}
                          <br />
                          {item.description}
                        </TableCell>
                        <TableCell>
                          <img src={item.childSignature} alt='Signature' style={{ width: 100 }} />
                        </TableCell>
                        <TableCell>{item.methodOfDisposal}</TableCell>
                        <TableCell>{item.dateOfDisposal}</TableCell>
                        <TableCell>
                          {item.staffName}
                          <img src={item.staffSignature} alt='Signature' style={{ width: 100 }} />
                        </TableCell>
                        <TableCell align='right'>
                          <IconButton color='primary' aria-label='delete' onClick={() => remove(index)}>
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </FieldArray>

          <Button color='primary' startIcon={<AddIcon />} onClick={() => setOpenAddItemDialog(true)} mt={2}>
            Add New Item
          </Button>

          <ReusableDialog
            isOpen={openAddItemDialog}
            onClose={() => setOpenAddItemDialog(false)}
            title='Add New Property Item'
            onSubmit={() => handleAddItem(setFieldValue, values.items)}
            contentText={"Add the relavent details to the fields to add a another perosn to the involved parties."}
            submitText='Add'
            cancelText='Cancel'
            disable={isAddButtonDisabled}
          >
            <Box mt={2}>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Date
                  </Typography>
                  <TextField
                    fullWidth
                    name='date'
                    type='date'
                    InputLabelProps={{ shrink: true }}
                    value={newItem.date}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={3}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Size
                  </Typography>
                  <TextField fullWidth name='size' type='number' value={newItem.size} onChange={handleInputChange} />
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Quantity
                  </Typography>
                  <TextField
                    fullWidth
                    name='quantity'
                    type='number'
                    value={newItem.quantity}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={12}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Team Description
                  </Typography>
                  <TextField
                    fullWidth
                    name='teamDescription'
                    value={newItem.teamDescription}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={4}>
                  <Autocomplete
                    id='staffName'
                    options={staffs}
                    value={newItem.staffName || values.staffName}
                    onChange={(event, newValue) => {
                      setFieldValue("staffName", newValue);
                      setNewItem((prevItem) => ({
                        ...prevItem,
                        staffName: newValue,
                      }));
                    }}
                    renderInput={(params) => (
                      <>
                        <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                          Staff Name
                        </Typography>
                        <TextField {...params} placeholder='Select' />
                      </>
                    )}
                    fullWidth
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={12}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Description
                  </Typography>
                  <TextField
                    fullWidth
                    name='description'
                    value={newItem.description}
                    onChange={handleInputChange}
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={12}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Method of Disposal
                  </Typography>
                  <TextField
                    fullWidth
                    name='methodOfDisposal'
                    value={newItem.methodOfDisposal}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} mt={1}>
                <Grid item xs={12} lg={6}>
                  <Typography sx={{ fontSize: "14px", color: "black" }} align='left'>
                    Date
                  </Typography>
                  <TextField
                    fullWidth
                    name='dateOfDisposal'
                    type='date'
                    InputLabelProps={{ shrink: true }}
                    value={newItem.dateOfDisposal}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
              {/* Signature */}
              <Box mt={2} xs={12} lg={6}>
                <Signature ref={signatureRef} />
                <Typography align='right'>
                  <Grid container>
                    <Grid>
                      <Typography sx={{ fontSize: "14px", color: "black" }}>Staff/ Signature </Typography>
                      <Typography>{newItem.dateOfDisposal}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                      Clear
                    </Button>
                  </Grid>
                </Typography>
              </Box>
              <Box mt={2} xs={12} lg={6}>
                <Signature ref={signatureRefChild} />
                <Typography align='right'>
                  <Grid container>
                    <Grid>
                      <Typography sx={{ fontSize: "14px", color: "black" }}>CYP/ Signature </Typography>
                      <Typography>{newItem.dateOfDisposal}</Typography>
                    </Grid>
                  </Grid>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Button variant='outlined' onClick={() => signatureRefChild.current?.clearSignature()}>
                      Clear
                    </Button>
                  </Grid>
                </Typography>
              </Box>
            </Box>
          </ReusableDialog>

          {/* Submit button */}
          <Grid item xs={12} mt={2}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default PropertyInventoryAdmission;
